import { Col, Form, Input, InputNumber, Row } from 'antd'
import TaxTypeSelect from 'elements/Select/Lines/TaxType'
import { get, isEmpty } from 'lodash'
import moment from 'moment'
import CustomSelect from '../../../../../elements/Select/CustomSelect'
import withSort from '../../../../../elements/HOC/withSort'
import withData from '../../../../../elements/Select/withData'
import { defaultFormItemLayout, fullWidthFormItemLayout } from '../../../../../modules/FormItems'
import { numVal, strVal } from '../../../../../modules/Utils'
import React, { useState, useEffect } from 'react'
import { compose } from 'recompose'

function RatesForm(props) {
  const { data, ProductsSelect, product, uom, setUom, history, setHistory, isNew } = props
  const { getFieldValue, setFieldsValue, getFieldDecorator, resetFields } = props.form

  const ProductLinesSelect = compose(
    withData({
      data: get(product, 'lines', []),
    }),
    withSort
  )(CustomSelect)

  React.useEffect(() => {
    if (!isEmpty(uom) && !isNew) {
      console.log(uom, product)
      setFieldsValue({
        'tax.percentage': get(uom, 'tax.percentage') || get(data, 'tax.percentage'),
        'tax.type': get(uom, 'tax.type') || get(data, 'tax.type'),
        rate: get(uom, 'price') || get(uom, 'rate') || get(data, 'rate'),
        description: get(uom, 'description') || get(data, 'description'),
      })

      if (isEmpty(history)) {
        setHistory([
          {
            rate: get(uom, 'price') || get(uom, 'rate') || get(data, 'rate'),
            date: moment().format('YYYY-MM-DD'),
            key: moment().millisecond(),
          },
        ])
      }
    }
  }, [uom])

  React.useEffect(() => {
    const _history = history.map((i) => ({ ...i, diff: moment(i.date).diff(moment(), 'days') }))
    console.log(_history)
    const latestPrice =
      history.length === 1
        ? history[0]
        : _history.filter((i) => i.diff >= 0).reduce((acc, v) => (acc.diff < v.diff ? acc : v), history[0])

    setFieldsValue({
      rate: get(latestPrice, 'rate', 0),
    })

    console.log(latestPrice)
  }, [history])

  return (
    <Form>

      <Row>
        <Col span={12}>
          <span>Product Code: {strVal(data, 'product.code')}</span>
        </Col>
        <Col span={12}>
          <Form.Item {...fullWidthFormItemLayout} label="Product">
            {getFieldDecorator('product._id', {
              initialValue: strVal(data, 'product._id'),
            })(<ProductsSelect />)}
          </Form.Item>
        </Col>
        <Col span={24}>
          <Form.Item {...fullWidthFormItemLayout} label="UOM">
            {getFieldDecorator('productLine._id', {
              initialValue: strVal(data, 'productLine._id'),
            })(<ProductLinesSelect keyAtr={'_id'} valueAtr={'name'} setSelected={setUom} />)}
          </Form.Item>
        </Col>

        <Col span={24}>
          <Form.Item {...fullWidthFormItemLayout} label="Description">
            {getFieldDecorator('description', {
              initialValue: strVal(data, 'description') || strVal(product, 'description'),
            })(<Input.TextArea rows={8} />)}
          </Form.Item>
        </Col>

        <Col span={12}>
          <Form.Item {...defaultFormItemLayout} label="Ref Product ID">
            {getFieldDecorator('ref', {
              initialValue: strVal(data, 'ref'),
            })(<Input placeholder={'ref'} />)}
          </Form.Item>
        </Col>

        <Col span={12}>
          <Form.Item {...defaultFormItemLayout} label="Current Rate">
            {getFieldDecorator('rate', {
              initialValue: numVal(data, 'rate'),
            })(<InputNumber disabled style={{ width: '100%' }} placeholder={'rate'} />)}
          </Form.Item>
        </Col>

        <Col span={12}>
          <Form.Item {...defaultFormItemLayout} label="Tax Type">
            {getFieldDecorator('tax.type', {
              initialValue: strVal(data, 'tax.type'),
            })(<TaxTypeSelect style={{ width: '100%' }} />)}
          </Form.Item>
        </Col>

        <Col span={12}>
          <Form.Item {...defaultFormItemLayout} label="Tax Percentage">
            {getFieldDecorator('tax.percentage', {
              initialValue: strVal(data, 'tax.percentage'),
            })(<InputNumber style={{ width: '100%' }} placeholder={'Tax percentage'} />)}
          </Form.Item>
        </Col>
      </Row>
    </Form>
  )
}

export default Form.create()(RatesForm)
